/** @override King Living: request the Icon Set appearance used by CF-053 and CF-054. */

import gql from 'graphql-tag';

export const BaseIconSetFragment = gql`
  fragment BaseIconSetFragment on IconSet {
    __typename
    sys {
      id
    }
    appearance
    title
    textColour
    backgroundColour
    jumpLink
    jumpLinkMarginTop
    maxItemsPerRowDesktop
  }
`;
